var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "24",
        height: "18",
        viewBox: "0 0 24 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("rect", {
        attrs: { y: "0.5", width: "24", height: "17", rx: "2", fill: "#244C72" }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M5.21495 11.584C4.38428 11.584 3.72628 11.3367 3.24095 10.842L3.77995 10.086C4.18128 10.506 4.67595 10.716 5.26395 10.716C5.52061 10.716 5.71895 10.667 5.85895 10.569C6.00361 10.4663 6.07595 10.3427 6.07595 10.198C6.07595 10.072 6.00828 9.967 5.87295 9.883C5.74228 9.799 5.57661 9.73833 5.37595 9.701C5.17995 9.66367 4.96528 9.61 4.73195 9.54C4.49861 9.47 4.28161 9.39067 4.08095 9.302C3.88495 9.21333 3.71928 9.07333 3.58395 8.882C3.45328 8.69067 3.38795 8.45733 3.38795 8.182C3.38795 7.78067 3.54895 7.44467 3.87095 7.174C4.19295 6.89867 4.62228 6.761 5.15895 6.761C5.90095 6.761 6.50761 6.978 6.97895 7.412L6.42595 8.14C6.05728 7.79933 5.60461 7.629 5.06795 7.629C4.85795 7.629 4.69461 7.671 4.57795 7.755C4.46128 7.839 4.40295 7.95333 4.40295 8.098C4.40295 8.21 4.46828 8.30567 4.59895 8.385C4.73428 8.45967 4.89995 8.51567 5.09595 8.553C5.29661 8.59033 5.51128 8.64633 5.73995 8.721C5.97328 8.791 6.18795 8.87267 6.38395 8.966C6.58461 9.05467 6.75028 9.197 6.88095 9.393C7.01628 9.58433 7.08395 9.81533 7.08395 10.086C7.08395 10.534 6.92295 10.8957 6.60095 11.171C6.28361 11.4463 5.82161 11.584 5.21495 11.584ZM11.3572 11.5H8.05321V6.831H11.3572V7.706H9.04721V8.693H11.3082V9.568H9.04721V10.625H11.3572V11.5ZM13.4283 11.5H12.4343V6.831H14.6183C15.1083 6.831 15.4909 6.97567 15.7663 7.265C16.0463 7.54967 16.1863 7.90667 16.1863 8.336C16.1863 8.76067 16.0463 9.11767 15.7663 9.407C15.4863 9.69633 15.1036 9.841 14.6183 9.841H13.4283V11.5ZM14.4853 8.966C14.6859 8.966 14.8493 8.91 14.9753 8.798C15.1059 8.68133 15.1713 8.52733 15.1713 8.336C15.1713 8.14467 15.1059 7.993 14.9753 7.881C14.8493 7.76433 14.6859 7.706 14.4853 7.706H13.4283V8.966H14.4853ZM20.9369 11.5H19.8029L19.5159 10.709H17.5139L17.2199 11.5H16.0859L17.8919 6.831H19.1379L20.9369 11.5ZM19.2429 9.834L18.5149 7.825L17.7869 9.834H19.2429Z",
          fill: "white"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }